
import { Vue, Component, Prop } from "vue-property-decorator";
import Loader from "@/components/Loader.vue";
import Gallery, { ResourceMeta } from "@/components/Gallery.vue";
import PrintButton from "@/components/PrintButton.vue";
import "@/helpers/filters";

@Component({ components: { Loader, Gallery, PrintButton } })
export default class Stammdaten extends Vue {
  @Prop({ required: true })
  id!: string;

  imageResourceMeta: ResourceMeta = {
    application: "chemie",
    resource: "foto",
    id: this.id
  };
}
